import button from 'assets/scss/_button.module.scss';
import style from 'assets/scss/tribes.module.scss';

export default function Tribes({ setTribesModal, setTribesResultModal, setResult }) {

    const handleImgClick = (val) => {
        setTribesResultModal(true);
        setResult(val);
    }

    return (
        <>
        <section id="tribes">
            <div className={`${style.__content} p-10`}>
                <div className="text-center text-2xl font-mm">Bruce Lee remains to be one<br/>of history’s most iconic figures.</div>
                <div className="text-center text-lg avenir-book">His influence transcends in various forms of media like art, video<br/>games, music, and many more. He impacts you in which way?</div>
                <div className="text-center text-lg avenir-book font-bold">Find your inner dragon today.</div>
                <button onClick={() => setTribesModal(true)} className={`${button.__redBtn} m-5 relative z-100`} style={{ zIndex: 999 }}>
                    <span className='text-xl'> Discover your purpose </span>
                </button>
                <div className="relative text-center" style={{ zIndex: 1 }}>
                    <div className="grid grid-cols-3 gap-[0.5rem] rotate-45" style={{ width: '100%' }}>
                        <div></div>
                        <div className={`${style.__imgHover} relative group`} onClick={() => handleImgClick("sage")}>
                            <div className="group-hover:invisible">
                                <div className={`${style.__imgWrapper} overflow-hidden bg-gray-700 flex flex-col`}>
                                    <img className={`${style.__tribeImg} -rotate-45 scale-[2.4]  translate-y-3 sm-translate-x-2 translate-x-0`} src="assets/img/tribe-section/Sage.jpeg" alt=""/>
                                </div>
                            </div>
                            <div className="invisible group-hover:visible">
                                <div className={`${style.__tribeTextHover} sm:text-xl text-sm`}>
                                    <span className="-rotate-45">Sage</span> 
                                </div>
                            </div>
                        </div>
                        <div className={`${style.__imgHover} relative group`} onClick={() => handleImgClick("caregiver")}>
                            <div className="group-hover:invisible">
                                <div className={`${style.__imgWrapper} overflow-hidden bg-gray-700 flex flex-col`}>
                                    <img className={`${style.__tribeImg} -rotate-45 scale-[2.5] md:translate-y-20 translate-y-7 -translate-x-7 ipadmini:-translate-x-[1rem] ipadmini:translate-y-[3rem]`} src="assets/img/tribe-section/Caregiver.jpg" alt=""/>
                                </div>
                            </div>
                            <div className="invisible group-hover:visible">
                                <div className={`${style.__tribeTextHover} sm:text-xl text-sm`}>
                                <span className="-rotate-45">Caregiver</span> 
                                </div>
                            </div>
                        </div>
                        <div className={`${style.__imgHover} relative group`} onClick={() => handleImgClick("creator")}>
                            <div className="group-hover:invisible">
                                <div className={`${style.__imgWrapper} overflow-hidden bg-gray-700 flex flex-col`}>
                                    <img className={`${style.__tribeImg} -rotate-45 scale-[2.1] scale-[2.1] translate-y-3`} src="assets/img/tribe-section/Creator.jpg" alt=""/>
                                </div>
                            </div>
                            <div className="invisible group-hover:visible">
                                <div className={`${style.__tribeTextHover} sm:text-xl text-sm`}>
                                    <span className="-rotate-45">Creator</span> 
                                </div>
                            </div>
                        </div>
                        <div className={`${style.__imgHover} relative group`} onClick={() => handleImgClick("explorer")}>
                            <div className="group-hover:invisible">
                                <div className={`${style.__imgWrapper} overflow-hidden bg-gray-700 flex flex-col`}>
                                    <img className={`${style.__tribeImg} -rotate-45 scale-[3.5] -translate-x-[4rem] translate-y-[4rem] ipadmini:-translate-x-[5rem] ipadmini:translate-y-[6rem] md:-translate-x-[7rem] md:translate-y-[8rem]`} src="assets/img/tribe-section/Explorer.jpg" alt=""/>
                                </div>
                            </div>
                            <div className="invisible group-hover:visible">
                                <div className={`${style.__tribeTextHover} sm:text-xl text-sm`}>
                                    <span className="-rotate-45">Explorer</span> 
                                </div>
                            </div>
                        </div>
                        <div></div>
                        <div className={`${style.__imgHover} relative group`} onClick={() => handleImgClick("game-changer")}>
                            <div className="">
                                <div className="group-hover:invisible">
                                    <div className={`${style.__imgWrapper} overflow-hidden bg-gray-700 flex flex-col`}>
                                        <img className={`${style.__tribeImg} -rotate-45 scale-[2.1] translate-y-3 translate-x-3`} src="assets/img/tribe-section/Game-Changer.jpg" alt=""/>
                                    </div>
                                </div>
                                <div className="invisible group-hover:visible"> 
                                    <div className={`${style.__tribeTextHover} sm:text-xl text-sm`}>
                                        <span className="-rotate-45">Game Changer</span> 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}